import React from 'react';
import UserRegistrationForm from '../../common/UserRegistrationForm';
import type { UserRegistrationDetails } from '../../../types/Registration';

interface UserDetailsStepProps {
  data: UserRegistrationDetails;
  onUpdate: (data: UserRegistrationDetails) => void;
  onNext: () => void;
  onBack?: () => void;
}

const UserDetailsStep: React.FC<UserDetailsStepProps> = ({ data, onUpdate, onNext, onBack }) => {
  const handleSubmit = (userDetails: UserRegistrationDetails) => {
    onUpdate(userDetails);
    onNext();
  };

  return (
    <UserRegistrationForm
      mode="signup"
      initialData={data}
      onSubmit={handleSubmit}
      onBack={onBack}
      title="Personal Information"
      description="Please provide your personal information to create your account."
      submitButtonText="Next: Agency Details"
    />
  );
};

export default UserDetailsStep;